"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var serializr_1 = require("serializr");
var FeedItem_1 = require("./FeedItem");
var FeedStore = /** @class */ (function () {
    function FeedStore(repository) {
        this.fetch = mobx_1.flow(function () {
            var response, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.repository.feed.list({
                                fieldset: 'comments',
                            })];
                    case 1:
                        response = _a.sent();
                        this.feedItems = response.data.feedItems.map(function (feedItem) { return new FeedItem_1.FeedItem(feedItem, _this.repository); });
                        this.cursor = response.data.nextPageCursor;
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error('FeedStore FeedItems fetch error: ', error_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
        this.create = mobx_1.flow(function (entity) {
            var response, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.repository.feed.create({
                                entity: entity,
                                fieldset: 'comments',
                            })];
                    case 1:
                        response = _a.sent();
                        this.feedItems.unshift(new FeedItem_1.FeedItem(response.data, this.repository));
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('FeedStore FeedItem create error: ', error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
        this.comment = mobx_1.flow(function (feedItemId, comment) {
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, this.feedItems
                        .find(function (feedItem) { return feedItem.feedItemId === feedItemId; })
                        .comment(comment)];
            });
        });
        this.repository = repository;
    }
    tslib_1.__decorate([
        serializr_1.serializable(serializr_1.list(serializr_1.object(FeedItem_1.FeedItem))),
        mobx_1.observable.shallow
    ], FeedStore.prototype, "feedItems", void 0);
    tslib_1.__decorate([
        serializr_1.serializable,
        mobx_1.observable
    ], FeedStore.prototype, "cursor", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "fetch", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], FeedStore.prototype, "create", void 0);
    return FeedStore;
}());
exports.FeedStore = FeedStore;
//# sourceMappingURL=FeedStore.js.map